// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar-module--navbar--3K-e1","logo":"navbar-module--logo--Ql6b7"};